import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute('/(redirects)/contact')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
})
